import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { alpha, SxProps } from "@mui/material";
import { CSSProperties, useContext } from "react";
import palette from "src/theme/palette";

import ThemeContext from "../context";

// ----------------------------------------------------------------------

interface Props extends LoadingButtonProps {
	sx?: SxProps;
	title: string;
	onClick: () => void;
}

export const ThemeBtn = ({ sx, onClick, title, disabled, ...props }: Props) => {
	const { theme } = useContext(ThemeContext);

	const buttonStyle: CSSProperties = {
		borderRadius: disabled ? "auto" : theme?.button.shape,
		backgroundColor: disabled
			? palette.light.grey[500]
			: props.variant === "text"
			? "auto"
			: theme?.colors.buttonBackground,
		color: props.variant === "text" ? theme?.colors.primary : theme?.colors.buttonText ?? "#fff",
		fontWeight: theme?.button.textWeight === "BOLD" ? 700 : 500,
		boxShadow:
			disabled || props.variant === "text"
				? "none"
				: `0 8px 16px 0 ${alpha(theme?.colors.buttonBackground ?? "#fff", 0.24)}`,
		fontSize: 14
	};

	return (
		<LoadingButton
			size='medium'
			style={buttonStyle}
			onClick={onClick}
			disabled={disabled}
			sx={sx}
			{...props}
		>
			{title}
		</LoadingButton>
	);
};

export default ThemeBtn;
